export interface MenuItem {
  label: string
  icon?: string
  children?: MenuItem[]
  route?: string
}

export const menuItems: MenuItem[] = [
  {
    label: 'FUNC.STATION.MANAGE',
    icon: 'building',
    children: [
      {
        label: 'FUNC.STATION.CREATE',
        icon: 'plus',
        route: '/create-site'
      },
      {
        label: 'FUNC.STATION.SEARCH',
        icon: 'search',
        route: '/search-site'
      }
    ]
  },
  {
    label: 'FUNC.ECHARGER.MANAGE',
    icon: 'charging-station',
    children: [
      {
        label: 'FUNC.ECHARGER.VIRTUAL',
        icon: 'cloud',
        route: '/virtual-echarger'
      }
    ]
  }
]
